import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaCalendarAlt } from 'react-icons/fa';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { Box, Grid, ModalBody, ModalCloseButton, ModalHeader } from '@tq/ui-components';

interface ReportModalContentProps {
  titleText: string;
  subTitleText: string;
}

export const ReportModalContent: React.FC<ReportModalContentProps> = ({
  titleText,
  subTitleText,
  children,
}) => {
  const { t } = useTranslation('report_modal');

  return (
    <>
      <ModalHeader aria-label={t('report_modal', 'Report modal')}>
        <Grid gridAutoFlow='column' gridGap={4}>
          <FaCalendarAlt color={COLOURS.blue[600]} />
          <span>{titleText}</span>
        </Grid>
        <ModalCloseButton />
      </ModalHeader>
      <ModalBody overflow='visible' p='0 !important'>
        <Box
          bg={COLOURS.gray[100]}
          borderTop={`1px solid ${COLOURS.gray[300]}`}
          borderBottom={`1px solid ${COLOURS.gray[300]}`}
          px={8}
          py={4}
        >
          <p>{subTitleText}</p>
        </Box>
        <Grid justifyContent='center' alignItems='center' py={8}>
          {children}
        </Grid>
      </ModalBody>
    </>
  );
};
